(function () {
  function showRelevantLink() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) || navigator.userAgent.includes('Windows');

    const appStoreLink = document.getElementById('app-store-link');
    const playStoreLink = document.getElementById('play-store-link');

    if (appStoreLink && isIOS) {
      appStoreLink.classList.remove('hidden');
    } else {
      if (playStoreLink) {
        playStoreLink.classList.remove('hidden');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', showRelevantLink);

})();